import { AppThunk } from 'redux/reducers/rootReducer';
import { ITableQueryData } from 'types/frontend_models/table/ITableQueryData';
import { defaultDataTablePageSize } from 'functions/tables/TableFunctions';
import { ITableData } from 'types/backend_models/shared/ITableData';
import { IProduct } from 'types/backend_models/products/IProduct';
import { IGenericDataFetchParams, createGenericTableDataFetch } from '../../generic/GenericDataActions';
import { setFetchProductsPending, setFetchProductsSucces, setFetchProductsError } from 'redux/reducers/data_action_reducers/products/overview/ProductsReducer';
import { builBackendTableQuery } from 'functions/backend/backendTableQueryBuilder';

export const initialQueryData: ITableQueryData = {
	sorted: '',
	filters: [],
	currentPage: 1,
	pageSize: defaultDataTablePageSize
}

var lastQueryData: ITableQueryData = initialQueryData;

export function getLastQueryData(): ITableQueryData
{
	return lastQueryData;
}

var fetchParams: IGenericDataFetchParams<ITableData<IProduct[]>> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchProductsPending,
	succesActionCreator: setFetchProductsSucces,
	errorActionCreator: setFetchProductsError
}

export function fetchProducts(data: ITableQueryData): AppThunk
{
	lastQueryData = data;
	const query = builBackendTableQuery(data);
	fetchParams.apiEndPoint = `customer/products${query}`;

	return createGenericTableDataFetch<IProduct[]>(fetchParams);
}